import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';

export interface LikesBoxContainerProps {
    isInteractive?: boolean;
    isLiked?: boolean;
}
export const LikesBoxContainer = styled(FlexBox)<LikesBoxContainerProps>`
    align-items: center;
    ${(p: LikesBoxContainerProps) => (p.isInteractive ? css`` : null)};
    ${(p: LikesBoxContainerProps) =>
        p.isLiked
            ? css`
                  svg * {
                      fill: white;
                  }
              `
            : null};
`;
import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';

export interface LikesBoxContainerProps {
    isInteractive?: boolean;
    isLiked?: boolean;
}
export const LikesBoxContainer = styled(FlexBox)<LikesBoxContainerProps>`
    align-items: center;
    ${(p: LikesBoxContainerProps) => (p.isInteractive ? css`` : null)};
    ${(p: LikesBoxContainerProps) =>
        p.isLiked
            ? css`
                  svg * {
                      fill: white;
                  }
              `
            : null};
`;
